import { IApplication } from "@rentiohq/shared-frontend/dist/types/application.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { Checkbox, Icon } from "@rentiohq/web-shared/dist/components";
import { useContext } from "react";
import { DragAndDropContext } from "../../context/DragAndDropContext";
import * as S from "./ApplicationTable.styled";

export type SortColumn =
  | "candidate"
  | "activity"
  | "income"
  | "rentmatch"
  | "rating"
  | null;
export type SortDirection = "asc" | "desc";

interface IProps {
  items: IApplication[];
  sortColumn: SortColumn;
  sortDirection: SortDirection;
  onSort: (column: SortColumn) => void;
}

export const ApplicationTableHeader = (props: IProps) => {
  const { items, sortColumn, sortDirection, onSort } = props;

  const { onSelectAll, onUnselectAll, selectedItems } =
    useContext(DragAndDropContext);

  const selectedItemIds = selectedItems.map(si => si.id);
  const isAllSelected =
    items.length > 0 && items.every(item => selectedItemIds.includes(item.id));

  const handleSelectAll = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isAllSelected) {
      onSelectAll(items);
    } else {
      onUnselectAll(items);
    }
  };

  const renderSortIndicator = (column: SortColumn) => {
    const isSorted = sortColumn === column;
    const iconSource =
      isSorted && sortDirection === "desc" ? "chevronDown" : "chevronUp";

    return (
      <S.SortIcon sorted={isSorted}>
        <Icon source={iconSource} size="small" />
      </S.SortIcon>
    );
  };

  return (
    <S.TableHeaderRow>
      <S.HeaderCheckboxCell>
        {items.length > 1 && (
          <Checkbox
            onChangeValue={handleSelectAll}
            checked={isAllSelected}
            appearance={isAllSelected ? "success" : "default"}
            error={false}
            disabled={items.length < 2}
          />
        )}
      </S.HeaderCheckboxCell>

      <S.HeaderCell sortable onClick={() => onSort("candidate")}>
        {getLocalizedText("general.candidate")}{" "}
        {renderSortIndicator("candidate")}
      </S.HeaderCell>

      <S.HeaderCell sortable onClick={() => onSort("rentmatch")}>
        Rentmatch {renderSortIndicator("rentmatch")}
      </S.HeaderCell>

      <S.HeaderCell sortable onClick={() => onSort("activity")}>
        {getLocalizedText("activity_table.info.heading")}{" "}
        {renderSortIndicator("activity")}
      </S.HeaderCell>

      <S.HeaderCell sortable onClick={() => onSort("income")}>
        {getLocalizedText("intake.financial.title")}{" "}
        {renderSortIndicator("income")}
      </S.HeaderCell>

      <S.HeaderCell>{getLocalizedText("system.more_info")}</S.HeaderCell>

      <S.HeaderCell sortable onClick={() => onSort("rating")}>
        {getLocalizedText("property.rating")} {renderSortIndicator("rating")}
      </S.HeaderCell>

      <S.HeaderCell />
    </S.TableHeaderRow>
  );
};
